import React, { useEffect } from 'react';
import { ChemistryOrbitFlow } from './components/ChemistryOrbitFlow';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { ProblemSolution } from './components/ProblemSolution';
import { SystemIntro } from './components/SystemIntro';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferStack } from './components/OfferStack';
import { MaterialPreview } from './components/MaterialPreview';
import { AudienceSection } from './components/AudienceSection';
import { Testimonials } from './components/Testimonials';
import { HowItWorks } from './components/HowItWorks';
import { Guarantee } from './components/Guarantee';
import { ClosingBlock } from './components/ClosingBlock';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'pl';
    document.title = 'Wizualna Chemia™ | Edycja 2026 — materiały dla nauczycieli chemii';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', '7 kompletnych tomów i 3 bonusy dla nauczycieli chemii: 568 stron gotowych do wydruku dla klas 7–8, liceum i technikum. Dostęp cyfrowy od razu.');
  }, []);
  return <div className="relative w-full bg-paper text-ink" data-id="element-0" data-mp="3dkuu1xylt8p4">
      <ChemistryOrbitFlow data-id="element-1" data-mp="3dmfprqwnmxok" />

      <div className="relative z-10" data-id="element-2" data-mp="3dii3wxiozs0z">
        <TopBar data-id="element-3" data-mp="nwc23tmizxws" />
        <main data-id="element-4" data-mp="nur7k407oeyx">
          <span id="hero-sentinel" aria-hidden="true" data-id="element-5" data-mp="nv0x5qhcgk43" />
          <Hero data-id="element-6" data-mp="su445ggvx0ep" />
          <TrustBar data-id="element-7" data-mp="stkn01z26g1q" />
          <ProblemSolution data-id="element-8" data-mp="st2i6gybyti7" />
          <SystemIntro data-id="element-9" data-mp="swglpsiqd8r8" />
          <VolumesSection data-id="element-10" data-mp="35ypel6klo1z" />
          <BonusesSection data-id="element-11" data-mp="356ttacz3qbp" />
          <OfferStack data-id="element-12" data-mp="38kwyktgo3k7" />
          <MaterialPreview data-id="element-13" data-mp="3uct2jhejuizf" />
          <AudienceSection data-id="element-14" data-mp="3udkm1tuvgq9c" />
          <Testimonials data-id="element-15" data-mp="3uc9jfxd5xojt" />
          <HowItWorks data-id="element-16" data-mp="3uf5i5nwu4h9b" />
          <Guarantee data-id="element-17" data-mp="d4e5lt427cwp" />
          <ClosingBlock data-id="element-18" data-mp="d3mlbefwx1lq" />
          <FAQ data-id="element-19" data-mp="d45vg8zbmlp7" />
        </main>
        <Footer data-id="element-20" data-mp="85l3ewu838bu" />
        <div className="h-[58px] md:hidden" aria-hidden="true" data-id="element-21" data-mp="85ul7x54696g" />
        <FloatingCTA data-id="element-22" data-mp="83i23gnmdsrt" />
      </div>
    </div>;
}